module.exports = __webpack_public_path__ + "static/img/noRace.4f7983bf.png";